import { Box, Icon, IconProps, Input, InputProps, Pressable } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const Container = Box.withConfig({
  _ios: {
    zIndex: Styles.zIndex.top,
  },
  _web: { zIndex: Styles.zIndex.top },
});

export const StyledAddressInput = Input.withConfig<{ inputCustomProps?: InputProps }>(
  ({ inputCustomProps = {} }) => ({
    fontSize: 'md',
    boxSize: '$12',
    color: inputCustomProps?.isDisabled
      ? theme.token('text-disabled')
      : theme.token('text-default'),
    backgroundColor: inputCustomProps?.isDisabled ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
    borderColor: theme.token('border-color-input-default'),
    borderWidth: 1,
    isDisabled: inputCustomProps?.isDisabled,
    ...inputCustomProps,
  })
);

export const StyledInputIcon = Icon.withConfig<{ rightIconCustomProps?: IconProps }>(
  ({ rightIconCustomProps }) =>
    rightIconCustomProps
      ? rightIconCustomProps
      : {
          marginRight: '$4',
          color: theme.token('icon-form-input-default'),
        }
);

export const OptionsListWrapper = Box.withConfig({
  shadow: '2',
  _android: {
    style: {
      elevation: Styles.zIndex.top,
    },
  },
  width: 'full',
  marginTop: '$12',
  position: 'absolute',
  zIndex: Styles.zIndex.top,
});

export const StyledOptionsListItem = Pressable.withConfig(
  ({ isHighlighted }: { isHighlighted?: boolean }) => ({
    paddingY: '$3',
    paddingX: '$4',
    borderWidth: 1,
    width: 'full',
    borderColor: theme.token('border-color-default'),
    backgroundColor: theme.token('background-input'),
    _pressed: {
      backgroundColor: theme.token('background-default'),
    },
    _hover: {
      backgroundColor: theme.token('background-default'),
    },
    _web: {
      cursor: 'pointer',
      justifyContent: 'center',
    },
    ...(isHighlighted && {
      backgroundColor: theme.token('background-default'),
    }),
  })
);
